export default "__VITE_ASSET__DZ1I1dxr__"